import { render, staticRenderFns } from "./TabInformationsOpportunity.vue?vue&type=template&id=506f0ace&"
import script from "./TabInformationsOpportunity.vue?vue&type=script&lang=js&"
export * from "./TabInformationsOpportunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports